module.exports = __webpack_public_path__ + "static/media/Artboard2.20a62a46.jpg";